import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import FullCalendar from "@fullcalendar/react";
import { harmonyRingEnabled } from "src/config/config";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  Tooltip,
  IconButton,
  Modal,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Alert,
  Chip,
  Stack,
} from "@mui/material";
import "@fullcalendar/daygrid/main.css";
import moment from "moment";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Checkbox from "@mui/material/Checkbox";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  add_edit_program_workout_member_api,
  copy_paste_member_workout,
  delete_program_workout_Api_all_membr,
  delete_program_workout_client_Api,
  reorder_member_events_api,
  set_program_difficulty_level_api,
} from "src/DAL/programmeWorkout/programmeWorkout";
import CustomConfirmation from "../ModalPopover/Confirmation";
import EditWorkoutPopupClient from "src/pages/Calender/EditWorkoutPopupClient";
import AddWorkoutPopupClient from "src/pages/Calender/component/AddWorkoutPopupClient";
import {
  addmmeberNoteApi,
  getmemberProgrammingNotes,
  getNotesProgramCalandar,
  inMemberProgramApiFroCalendar,
} from "src/DAL/NotesApi/Notes";
import GeneralCkeditor from "../GeneralCkeditor";
import { SHOW_PASTE_CONFIRMATION } from "src/utils/constant";
import PastedWorkoutsClient from "./PastedWorkoutsClient";
import { _get_day_calories_local } from "src/DAL/localstorage/LocalStorage";
import EventCardClient from "./EventCardClient";
import CustomPopoverNew from "../CustomPopoverNew";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import ReviewsDate from "./ReviewsDate";
import ReviewsDateMember from "./ReviewsDateMember";
import { useQueryClient } from "@tanstack/react-query";
import { normalize_workout_date } from "src/utils/constant";
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

// Height of the month-arrows strip that sticks above the day-name header on scroll.
const STICKY_NAV_HEIGHT = 40;

function GeneralCalendarClient({
  programWorkoutList,
  reorderedWorkoutList,
  setCurrentDate,
  time_zone,
  currentDate,
  isLoading,
  reloadList,
  calendar_title,
  programme,
  member_id,
  member_vdot,
  member_vdot_info,
  type_member,
  isPasted,
  setIsPasted,
  show_back_button,
  difficultyProgram,
  calendarRef,
  goToToday,
  memberInfo,
  isMemberCalendar,
  manualLoading,
  initialDate,
}) {
  const INITIAL_VALUES = {
    title: "",
    description: "",
    categories: [],
    status: true,
    image: null,
    imagePreview: null,
    videoURL: "",
  };
  const [events, setEvents] = useState([]);
  const [inputs, setInputs] = useState(INITIAL_VALUES);
  let menstrual_cycle = _get_day_calories_local();
  const [programmeData, setProgrammeData] = useState(programme);
  const navigate = useNavigate();
  const classes = useStyles();
  const queryClient = useQueryClient();
  const [openEditor, setOpenEditor] = useState(false);
  const [drawerState, setDrawerState] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openDragConfig, setOpenDragConfig] = useState(false);
  const [DragConfigDate, setDragConfigDate] = useState(false);
  const [DragConfigData, setDragConfigData] = useState(false);
  const [openCopyPasteConfig, setOpenCopyPasteConfig] = useState(false);
  const [pasteDate, setPasteDate] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [editItrationDrawerState, setEditItrationDrawerState] = useState();
  const [hoveredDate, setHoveredDate] = useState(null);
  const [selectedDate, setSelectDate] = useState("");
  const [dataDel, setDataDel] = useState();
  const [editWorkputData, setEditWorkputData] = useState();
  const [dataCopy, setDataCopy] = useState();
  const [selectedWorkouts, setSelectedWorkouts] = useState([]);
  const [pastedWorkouts, setPastedWorkouts] = useState([]);
  const [hoverdInfo, setHoverdInfo] = useState(null);
  const [open, setOpen] = useState(false);
  const [openMultiDelete, setOpenMultiDelete] = useState(false);
  const [isPastedWorkouts, setIsPastedWorkouts] = useState(false);
  const [openLevels, setOpenLevels] = useState(false);
  const [isOpen, setIsOpen] = useState("ADD");
  const [difficultyLevel, setDifficultyLevel] = useState("");
  const [isReviewOpen, setIsReviewOpen] = useState(false);
  const {
    setIsOpenNotePad,
    setSelectedNotepad,
    setPageTitle,
    setShowNavBackButton,
    setNavbarSubtitle,
  } = useContentSetting();
  const [isDragedloading, setIsDragedloading] = useState(false);
  const [openWorkoutIds, setOpenWorkoutIds] = useState(new Set());
  const [globalOpen, setGlobalOpen] = useState(true);
  // Ref so getEventListing can read the latest globalOpen value synchronously
  const globalOpenRef = React.useRef(true);
  React.useEffect(() => {
    globalOpenRef.current = globalOpen;
  }, [globalOpen]);

  const toolbarRowRef = useRef(null);
  // Position of the month arrows while the day-name header is fixed (null when it is not).
  const [stickyNav, setStickyNav] = useState(null);

  const member = useParams();

  const [searchParams, setSearchParams] = useSearchParams();

  const handleOpen = () => {
    let message = !type_member
      ? "This notepad is specific to this member only. (Member's programming notepad)"
      : "This notepad is specific to this member for the selected programme.";
    let name = type_member
      ? programme?.title
      : programme.first_name + " " + programme?.last_name;
    let data = {
      title: name,
      _id: programme?._id,
      member_id: member_id,
      type_member: type_member,
      message: message,
    };
    setSelectedNotepad(data);
    setIsOpenNotePad(true);
  };

  const handleOpenMultiDelete = () => {
    setOpenMultiDelete(true);
  };

  const handleProgrammeMember = () => {
    setIsPastedWorkouts(true);
  };

  const getNotesList = async () => {
    if (type_member && !programme?._id) {
      return;
    }

    const result = type_member
      ? await getNotesProgramCalandar(member_id, programme?._id)
      : await getmemberProgrammingNotes(member_id);

    if (result.code === 200) {
      setProgrammeData((old) => ({
        ...old,
        is_allow_workbook: result?.program?.is_allow_workbook,
      }));
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    getNotesList();
  }, [member_id, programme?._id]);

  useEffect(() => {
    let title = calendar_title || "";
    let subtitle = "";
    if (type_member && memberInfo?.email) {
      const fullName = `${memberInfo?.first_name || ""} ${
        memberInfo?.last_name || ""
      }`.trim();
      subtitle = fullName
        ? `${fullName} (${memberInfo.email})`
        : memberInfo.email;
    }
    if (title && !isMemberCalendar) {
      setPageTitle(title);
    }
    setNavbarSubtitle(subtitle);
    setShowNavBackButton(!!show_back_button);
    return () => {
      setPageTitle("");
      setNavbarSubtitle("");
      setShowNavBackButton(false);
    };
  }, [calendar_title, show_back_button, type_member, memberInfo]);

  useEffect(() => {
    if (programme) {
      setProgrammeData(programme);
    }
  }, [programme]);

  const handleCellHover = (info) => {
    setHoveredDate(info.date);
    setHoverdInfo(info);
  };

  const clearModalParams = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("modal");
    params.delete("workoutId");
    // Keep the date param so calendar stays on the same month after modal closes
    setSearchParams(params, { replace: true });
  };

  const handleCloseAddModal = () => {
    setDrawerState(false);
    clearModalParams();
  };

  const handleCloseEditModal = () => {
    setEditItrationDrawerState(false);
    clearModalParams();
  };

  const isFirstEventOnDate = (test) => {
    let date = normalize_workout_date(test.workout_date);
    const sameDateEvents = [...events]
      .filter((e) => e.date === date)
      .sort((a, b) => a.order - b.order); // Ensure sorting by order
    return sameDateEvents.length > 0 && sameDateEvents[0]._id === test._id;
  };

  const isLastEventOnDate = (test) => {
    let date = normalize_workout_date(test.workout_date);
    const sameDateEvents = [...events]
      .filter((e) => e.date === date)
      .sort((a, b) => a.order - b.order);
    return (
      sameDateEvents.length > 0 &&
      sameDateEvents[sameDateEvents.length - 1]._id === test._id
    );
  };

  const handleCloseEditor = () => {
    setOpenEditor(false);
  };

  const isWorkoutSelected = (workout) =>
    selectedWorkouts.some((item) => item._id === workout?._id) ||
    (pastedWorkouts &&
      pastedWorkouts.some((item) => item._id === workout?._id));
  const handleScrollCalled = (data) => {
    const todayCell = document.querySelector(
      `.calendar-workout-card[id="${data}"]`,
    );

    todayCell.scrollIntoView({ behavior: "instant", block: "center" });
  };

  const handleCopyExercise = (data) => {
    setEditWorkputData();
    setPastedWorkouts();
    setSelectedWorkouts((prevSelected) => {
      const updatedSelected = prevSelected.some(
        (workout) => workout?._id === data._id,
      )
        ? prevSelected.filter((workout) => workout?._id !== data._id)
        : [...prevSelected, data];

      if (updatedSelected.length > 0) {
        setDataCopy(true);
      } else {
        setDataCopy(false);
      }
      return updatedSelected;
    });
  };

  const handleOpenDrawer = (arg) => {
    setSelectDate(arg);
    setDrawerState(true);
    const params = new URLSearchParams(searchParams);
    params.set("modal", "add");
    params.set("date", moment(arg).format("YYYY-MM-DD"));
    setSearchParams(params, { replace: true });
  };

  const handlePaste = async (arg) => {
    if (isPasted) return;

    setPasteDate(arg);
    if (SHOW_PASTE_CONFIRMATION) {
      setOpenCopyPasteConfig(true);
    } else {
      await handleCopyPaste(arg);
    }
  };

  const handleCopyPaste = async (dateArg) => {
    setIsPasted(true);
    const workoutsIds = selectedWorkouts.map((workout) => workout?._id);

    const targetDate = dateArg || pasteDate;

    const formDataObject = {
      copiedWorkoutIds: workoutsIds,
      targetStartDate: moment(targetDate).format("YYYY-MM-DD"),
      member_id: member_id,
    };

    try {
      const result = await copy_paste_member_workout(formDataObject);
      if (result.code === 200) {
        setPastedWorkouts(result?.copiedWorkouts);
        setSelectedWorkouts([]);
        setDataCopy(false);
        reloadList(
          result?.copiedWorkouts[0]?._id,
          result.message,
          SHOW_PASTE_CONFIRMATION ? setOpenCopyPasteConfig : null,
          true, // skipScroll — scroll position will be restored by parent
        );
        setIsPasted(false);
      } else {
        setSelectedWorkouts([]);
        enqueueSnackbar(result.message, { variant: "error" });
        setDataCopy(false);
        setIsPasted(false);
      }
    } catch (error) {
      setSelectedWorkouts([]);
      enqueueSnackbar("Failed to paste workouts", { variant: "error" });
      setDataCopy(false);
      setIsPasted(false);
    }
  };

  const closeCopyPasteConfig = async (value) => {
    setPastedWorkouts([]);
    setSelectedWorkouts([]);
    setOpenCopyPasteConfig(false);
    setDataCopy(false);
    getEventListing(events, time_zone);
  };

  const handleAgreeDelete = (data) => {
    setDataDel(data);
    setOpenDelete(true);
  };

  const handleOpenEditIterationDrawer = () => {
    setEditItrationDrawerState(true);
  };

  const handleUpdateIteration = (data) => {
    setEditWorkputData(data);
    handleOpenEditIterationDrawer();
    const params = new URLSearchParams(searchParams);
    params.set("modal", "edit");
    params.set("workoutId", data?._id);
    params.set("date", moment(data?.workout_date).format("YYYY-MM-DD"));
    setSearchParams(params, { replace: true });
  };

  const closeDragConfig = async (value) => {
    setOpenDragConfig(false);
    getEventListing(programWorkoutList, time_zone);
  };

  const handleDelete = async (value) => {
    setOpenDelete(false);
    let postData = {
      member_id: member_id,
      workout_id: dataDel?._id,
    };
    const result = await delete_program_workout_client_Api(postData);
    if (result.code === 200) {
      setEditWorkputData();
      enqueueSnackbar(result.message, { variant: "success" });
      let updatedEvents = events.filter((item) => item._id != dataDel._id);
      setEvents(updatedEvents);
      const today = normalize_workout_date(dataDel?.workout_date);
      const todayCell = document.querySelector(`.fc-day[data-date="${today}"]`);
      if (todayCell) {
        todayCell.scrollIntoView({ behavior: "instant", block: "start" });
      }
      setPastedWorkouts([]);
      setSelectedWorkouts([]);
      setDataCopy(false);
      if (isMemberCalendar) {
        queryClient.invalidateQueries({ queryKey: ["memberCalendar"] });
      } else {
        queryClient.invalidateQueries({ queryKey: ["memberCalendarEvents"] });
      }
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleDeleteMultipul = async () => {
    setOpenMultiDelete(false);
    const postData = {
      workout_ids: selectedWorkouts.map((workout) => workout?._id),
      member_id: member_id,
    };
    const result = await delete_program_workout_Api_all_membr(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });

      let updatedEvents = events.filter(
        (item) => !postData.workout_ids.includes(item._id),
      );
      setEvents(updatedEvents);
      setEditWorkputData();
      setPastedWorkouts([]);
      setSelectedWorkouts([]);
      setDataCopy(false);
      if (isMemberCalendar) {
        queryClient.invalidateQueries({ queryKey: ["memberCalendar"] });
      } else {
        queryClient.invalidateQueries({ queryKey: ["memberCalendarEvents"] });
      }
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleDraged = async (value) => {
    setIsDragedloading(true);
    const programId =
      DragConfigData?.program_info?.program_id || DragConfigData?.program_id;

    const formDataObject = {
      title: DragConfigData?.workout_title,
      description: DragConfigData?.description,
      exercises: DragConfigData?.workout_exercises,
      program_id: programId,
      library_type:
        DragConfigData?.practice_type === "workbook"
          ? DragConfigData?.library_type
          : "",
      questions: DragConfigData?.questions || [],
      practice_type: DragConfigData?.practice_type,
      member_id: member_id,
      _id: DragConfigData?._id,
      workout_date: moment(DragConfigDate).format("YYYY-MM-DD"),
      video_url: DragConfigData?.video_url,
      video_thumbnail: DragConfigData?.video_thumbnail || {},
      difficulty_levels: DragConfigData?.difficulty_levels || [],
      comment: DragConfigData?.comment,
    };
    const formData = new FormData();

    formData.append("title", formDataObject.title);
    formData.append("description", formDataObject.description);
    formData.append("questions", JSON.stringify(formDataObject?.questions));
    formData.append("library_type", formDataObject?.library_type);
    formData.append("program_id", formDataObject.program_id);
    formData.append("practice_type", formDataObject.practice_type);
    formData.append("comment", DragConfigData?.comment);
    formData.append("target_day", DragConfigData?.target_day);
    formData.append("meals", JSON.stringify(DragConfigData?.meals || []));
    formData.append("member_id", formDataObject.member_id);
    formData.append("_id", formDataObject._id);
    formData.append(
      "workout_dates",
      JSON.stringify([formDataObject.workout_date]),
    );
    formData.append(
      "video_url",
      formDataObject.video_url ? formDataObject.video_url : "",
    );
    if (formDataObject.video_thumbnail) {
      formData.append(
        "duplicate_image_path",
        JSON.stringify(formDataObject.video_thumbnail),
      );
    }
    formData.append(
      "difficulty_levels",
      JSON.stringify(formDataObject.difficulty_levels),
    );
    formData.append("exercises", JSON.stringify(formDataObject.exercises));
    const result = await add_edit_program_workout_member_api(formData);
    if (result.code === 200) {
      setEditWorkputData(DragConfigData);
      reloadList(DragConfigData?._id, result.message, setOpenDragConfig);
      setTimeout(() => {
        setIsDragedloading(false);
      }, 2000);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsDragedloading(false);
      getEventListing(programWorkoutList, time_zone);
    }
  };

  const handleReorder = async (newdate, newevents) => {
    const sortedEvents = [...newevents].sort((a, b) => a.order - b.order);
    const ids = sortedEvents.map((event) => event._id);
    let postData = {
      workoutIds: ids,
      member: member_id,
      workout_date: moment(newdate).format("YYYY-MM-DD"),
    };
    const result = await reorder_member_events_api(postData);
    if (result.code !== 200) {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleToggleWorkout = (workoutId) => {
    setOpenWorkoutIds((prev) => {
      const next = new Set(prev);
      if (next.has(workoutId)) {
        next.delete(workoutId);
      } else {
        next.add(workoutId);
      }
      return next;
    });
  };

  const handleExpandAll = () => {
    setGlobalOpen(true);
    globalOpenRef.current = true;
    setOpenWorkoutIds(new Set(events.map((e) => e._id)));
  };

  const handleCollapseAll = () => {
    setGlobalOpen(false);
    globalOpenRef.current = false;
    setOpenWorkoutIds(new Set());
  };

  // Sync isOpen field into events so FullCalendar detects data changes and re-renders
  // useMemo ensures this only recomputes when events or openWorkoutIds change,
  // NOT on every hover — preventing FullCalendar from resetting scroll on cursor move.
  const eventsWithOpenState = useMemo(
    () =>
      events.map((e) => ({
        ...e,
        isOpen: openWorkoutIds.has(e._id),
      })),
    [events, openWorkoutIds],
  );

  const renderEventContent = useCallback(
    (eventInfo) => {
      const workoutId = eventInfo.event?.extendedProps?._id;
      const isOpen = !!eventInfo.event?.extendedProps?.isOpen;
      return (
        <EventCardClient
          workout={eventInfo.event}
          handleReorder={handleReorder}
          isWorkoutSelected={isWorkoutSelected}
          editWorkputData={editWorkputData}
          isFirstEventOnDate={isFirstEventOnDate}
          isLastEventOnDate={isLastEventOnDate}
          handleScrollCalled={handleScrollCalled}
          handleCopyExercise={handleCopyExercise}
          handleAgreeDelete={handleAgreeDelete}
          setEditWorkputData={setEditWorkputData}
          setEvents={setEvents}
          events={events}
          handleUpdateIteration={handleUpdateIteration}
          isOpen={isOpen}
          onToggle={handleToggleWorkout}
        />
      );
    },
    [events, editWorkputData, selectedWorkouts, pastedWorkouts, openWorkoutIds],
  );

  const getEventListing = async (workout) => {
    let all_events = [];
    if (workout?.length > 0) {
      all_events = workout?.map((workout, i) => ({
        ...workout,
        title: workout?.title || "",
        color: workout?.program_info?.color,
        workout_color: workout?.program_info?.color,
        workout_title: workout?.title || "",
        workout_exercises: workout?.exercises,
        workout_program: workout?.program_info,
        is_deleteAble: workout?.workout_has_logs ? false : true,
        workout_completed: workout?.workout_completed,
        status: workout?.status,
        open: globalOpenRef.current,
        date: normalize_workout_date(workout?.workout_date),
        index: i,
        order: i,
        editable: workout?.workout_has_logs ? false : true,
      }));
    }

    const eventsDict = {};
    all_events.forEach((event) => {
      eventsDict[event._id] = event;
    });

    let reorderedEvents = [];
    let remainingEvents = [...all_events];

    reorderedWorkoutList.forEach((workout) => {
      const { workout_date, reorder_workouts } = workout;

      reorder_workouts.forEach((workout_id, index) => {
        if (eventsDict[workout_id]) {
          const event = eventsDict[workout_id];
          event.order = index;
          reorderedEvents.push(event);

          remainingEvents = remainingEvents.filter((e) => e._id !== workout_id);
        }
      });

      const remainingSameDateEvents = remainingEvents.filter(
        (event) => event.workout_date === workout_date,
      );

      reorderedEvents.push(...remainingSameDateEvents);
      remainingEvents = remainingEvents.filter(
        (event) => event.workout_date !== workout_date,
      );
    });

    reorderedEvents.push(...remainingEvents);
    const uniqueEvents = [];
    const seenIds = new Set();
    reorderedEvents.forEach((event) => {
      if (!seenIds.has(event._id)) {
        seenIds.add(event._id);
        uniqueEvents.push(event);
      }
    });
    setEvents(uniqueEvents);
    // Sync openWorkoutIds with the new global state so FullCalendar re-renders correctly
    if (globalOpenRef.current) {
      setOpenWorkoutIds(new Set(uniqueEvents.map((e) => e._id)));
    } else {
      setOpenWorkoutIds(new Set());
    }
  };

  const getCenteredText = () => {
    let text = moment(new Date()).format("MMM YYYY");
    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();
      const currentMonth = calendarApi.getDate().getMonth();
      const currentYear = calendarApi.getDate().getFullYear();
      text = moment().month(currentMonth).format("MMM") + " " + currentYear;
    }
    return text;
  };

  const hanldeChangeDates = (value) => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;

    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();

      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
    let new_object = {};
    if (value == "next") {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    } else {
      new_object = {
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
    }
    setCurrentDate(new_object);
  };

  const handleChangeNextPrev = (value) => {
    let classToClick = "fc-next-button";
    if (value == "prev") {
      classToClick = "fc-prev-button";
    }
    let click_element = document.getElementsByClassName(classToClick)[0];
    click_element.click();
    hanldeChangeDates(value);
    // Update date param to reflect new month, remove modal params
    if (calendarRef?.current) {
      const calendarApi = calendarRef.current.getApi();
      const newDate = moment(calendarApi.getDate()).format("YYYY-MM-DD");
      const params = new URLSearchParams(searchParams);
      params.set("date", newDate);
      params.delete("modal");
      params.delete("workoutId");
      setSearchParams(params, { replace: true });
    }
  };

  // Arrows in the sticky strip: change month, then show the new month from its top.
  const handleStickyNextPrev = (value) => {
    handleChangeNextPrev(value);
    const toolbarEl = toolbarRowRef.current;
    if (toolbarEl && stickyNav) {
      window.scrollTo({
        top: window.scrollY + toolbarEl.getBoundingClientRect().top - stickyNav.top,
        behavior: "instant",
      });
    }
  };

  const handleClickDate = (workout) => {
    setCurrentDate({
      start_date: workout?.dateStr,
      end_date: workout?.dateStr,
    });
  };

  const handleEventDrop = (info) => {
    const { event } = info;
    const eventData = event.extendedProps;
    setOpenDragConfig(true);
    setDragConfigDate(event.start);
    setDragConfigData(eventData);
  };

  const [checked, setChecked] = useState(false);

  const handleChangeCheck = (event) => {
    setChecked(event.target.checked);
  };

  const handleAddLevels = async () => {
    if (!difficultyLevel) {
      return enqueueSnackbar(`Please Select Levels`, { variant: "error" });
    }
    let postData = {
      program_id: programme?._id,
      member_id: member_id,
      difficulty_level: difficultyLevel,
    };

    let result = await set_program_difficulty_level_api(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setOpenLevels(false);
      reloadList();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const renderDayCell = (arg) => {
    const isHovered =
      hoveredDate && arg.date.getTime() === hoveredDate.getTime();
    return (
      <div
        style={{
          position: "relative",
          height: "100%",
          marginTop: -10,
        }}
      >
        <span>{arg?.dayNumberText}</span>{" "}
        <span
          className="day-cell-name"
          style={{
            opacity: 0.5,
            fontSize: 10,
          }}
        >
          {moment(arg?.date).format("ddd")}
        </span>
        {isHovered && (
          <div className="cell-icon-workout d-flex text-end w-100">
            {dataCopy && (
              <Tooltip touch="on" placement="bottom" title={"Paste"}>
                <div
                  className="paste-icon-workout-general me-1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "19px",
                    minHeight: "19px",
                  }}
                >
                  <AssignmentTurnedInIcon
                    onClick={() => handlePaste(arg?.date)}
                    sx={{
                      cursor: "pointer",
                      height: 15,
                      width: 15,
                    }}
                  />
                </div>
              </Tooltip>
            )}

            <AddIcon
              className="add-icon-workout-general "
              onClick={() => handleOpenDrawer(arg?.date)}
              sx={{
                cursor: "pointer",
              }}
            />
          </div>
        )}
      </div>
    );
  };

  const handleViewGraph = (value) => {
    navigate(
      `/member/${member?.id}/member-MemberCalendar/${member?.CalId}/graph`,
      {
        state: value,
      },
    );
  };

  useEffect(() => {
    let start_date = currentDate.start_date;
    let end_date = currentDate.end_date;

    if (calendarRef?.current) {
      const calendarApi = calendarRef?.current.getApi();

      const currentView = calendarApi.view;
      const startDate = currentView.activeStart;
      const endDate = currentView.activeEnd;
      start_date = startDate;
      end_date = endDate;
    }
  }, [calendarRef]);

  function getNewDates(refDate, inputDate) {
    const dateDifferences = [];
    const referenceDates = refDate
      .map((date) => new Date(date.split("/").reverse().join("-")))
      .sort((a, b) => a - b);

    for (let i = 1; i < referenceDates.length; i++) {
      const diffInDays =
        (referenceDates[i] - referenceDates[i - 1]) / (1000 * 60 * 60 * 24);
      dateDifferences.push(diffInDays);
    }

    const newDates = [new Date(inputDate.split("/").reverse().join("-"))];

    for (let diff of dateDifferences) {
      const nextDate = new Date(newDates[newDates.length - 1]);
      nextDate.setDate(nextDate.getDate() + diff);
      newDates.push(nextDate);
    }

    newDates.sort((a, b) => a - b);

    return newDates.map((date) =>
      date.toLocaleDateString("en-GB").split("/").join("/"),
    );
  }

  useEffect(() => {
    if (!hoverdInfo) return;

    const cellDate = moment(hoverdInfo?.date).format("DD/MM/YYYY");

    const dates = selectedWorkouts.map((workout) => {
      return moment.utc(workout?.workout_date).format("DD/MM/YYYY");
    });

    let newDates = [];
    if (dates.length > 0 && cellDate) {
      newDates = getNewDates(dates, cellDate);
    }

    document.querySelectorAll(".fc-daygrid-day").forEach((cell) => {
      cell.classList.remove("highlighted-hover");
    });

    if (newDates.length > 0) {
      document.querySelectorAll(".fc-daygrid-day").forEach((cell) => {
        const cellDate = moment(cell.getAttribute("data-date")).format(
          "DD/MM/YYYY",
        );

        if (newDates.includes(cellDate)) {
          cell.classList.add("highlighted-hover");
        }
      });
    }
  }, [hoverdInfo, selectedWorkouts]);

  useEffect(() => {
    getEventListing(programWorkoutList, time_zone);
  }, [programWorkoutList]);

  useEffect(() => {
    const modalType = searchParams.get("modal");
    const dateParam = searchParams.get("date");

    if (modalType !== "add" || !dateParam) return;

    // Case: invalid date → remove all params including date
    if (!moment(dateParam, "YYYY-MM-DD", true).isValid()) {
      const params = new URLSearchParams(searchParams);
      params.delete("modal");
      params.delete("workoutId");
      params.delete("date");
      setSearchParams(params, { replace: true });
      return;
    }

    // Valid date — check if it's in the currently visible month
    if (calendarRef?.current) {
      const calendarApi = calendarRef.current.getApi();
      const targetDate = moment(dateParam).toDate();
      const currentViewStart = calendarApi.view.activeStart;
      const currentViewEnd = calendarApi.view.activeEnd;
      const isAlreadyVisible =
        targetDate >= currentViewStart && targetDate < currentViewEnd;
      if (!isAlreadyVisible) {
        // Navigate to target month first, modal will open on next render
        calendarApi.gotoDate(targetDate);
        setCurrentDate({
          start_date: calendarApi.view.activeStart,
          end_date: calendarApi.view.activeEnd,
        });
        return;
      }
    }
    const date = moment(dateParam).toDate();
    setSelectDate(date);
    setDrawerState(true);
  }, [searchParams]);

  useEffect(() => {
    if (!programWorkoutList || programWorkoutList.length === 0) return;

    const modalType = searchParams.get("modal");
    const dateParam = searchParams.get("date");
    const workoutId = searchParams.get("workoutId");

    if (modalType !== "edit" || !workoutId) return;

    const workout = programWorkoutList.find((w) => w._id === workoutId);
    if (workout) {
      // Workout found — open modal
      setEditWorkputData(workout);
      setEditItrationDrawerState(true);
    } else if (dateParam && moment(dateParam, "YYYY-MM-DD", true).isValid()) {
      // Valid date but workout not in current month's data
      // Navigate calendar to that month so parent fetches it
      if (calendarRef?.current) {
        const calendarApi = calendarRef.current.getApi();
        const targetDate = moment(dateParam).toDate();
        const currentViewStart = calendarApi.view.activeStart;
        const currentViewEnd = calendarApi.view.activeEnd;
        const isAlreadyVisible =
          targetDate >= currentViewStart && targetDate < currentViewEnd;
        if (!isAlreadyVisible) {
          // Navigate to target month to trigger data fetch
          calendarApi.gotoDate(targetDate);
          setCurrentDate({
            start_date: calendarApi.view.activeStart,
            end_date: calendarApi.view.activeEnd,
          });
        } else {
          // Already on correct month but workout not found → deleted workout
          // Stay on this month, just clear modal params
          clearModalParams();
        }
      } else {
        clearModalParams();
      }
    } else {
      // Invalid date or no date → remove all params including date
      const params = new URLSearchParams(searchParams);
      params.delete("modal");
      params.delete("workoutId");
      params.delete("date");
      setSearchParams(params, { replace: true });
    }
  }, [searchParams, programWorkoutList]);

  useEffect(() => {
    const isMemberInfoLoaded = memberInfo && Object.keys(memberInfo).length > 0;

    let memberDifficultyLevel = null;
    if (isMemberInfoLoaded && memberInfo.program && programme?._id) {
      const currentProgramme = memberInfo.program.find(
        (prog) => prog._id === programme._id,
      );
      memberDifficultyLevel = currentProgramme?.member_difficutly_level;
    }

    if (
      isMemberInfoLoaded &&
      !memberDifficultyLevel &&
      show_back_button &&
      programme?.difficulty_level
    ) {
      setOpenLevels(true);
      setIsOpen("ADD");
    }
  }, [memberInfo, programme, show_back_button]);

  useEffect(() => {
    if (memberInfo?.program && programme?._id) {
      const currentProgramme = memberInfo.program.find(
        (prog) => prog._id === programme._id,
      );
      const level = currentProgramme?.member_difficutly_level;
      if (level) {
        setDifficultyLevel(level);
      }
    }
  }, [memberInfo, programme]);

  const eventOrderFunction = (a, b) => {
    return a.order - b.order;
  };

  // ---------- Sticky day-name + date header on scroll ----------
  useEffect(() => {
    let isHeaderFixed = false;
    let headerPlaceholder = null;
    const originalCellTexts = new Map();

    const getNavbarHeight = () => {
      const navbar =
        document.querySelector(".mini-drawer-menu-title") ||
        document.querySelector("header") ||
        document.querySelector("nav");
      return navbar ? navbar.getBoundingClientRect().height : 64;
    };

    const getColHeader = () => document.querySelector(".fc .fc-col-header");

    const getTableWidth = () => {
      const fcTable = document.querySelector(".fc .fc-scrollgrid");
      return fcTable ? fcTable.getBoundingClientRect().width : 0;
    };

    const injectDatesIntoHeader = (weekRow) => {
      const fcColHeader = getColHeader();
      if (!fcColHeader || !weekRow) return;

      const headerCells = fcColHeader.querySelectorAll(
        ".fc-col-header-cell-cushion",
      );
      const dayCells = weekRow.querySelectorAll(".fc-daygrid-day");
      if (!headerCells.length || !dayCells.length) return;

      dayCells.forEach((cell, i) => {
        const cushion = headerCells[i];
        if (!cushion) return;

        const dayNumberEl = cell.querySelector(".fc-daygrid-day-number");
        const dateText = dayNumberEl ? dayNumberEl.textContent.trim() : "";

        if (!originalCellTexts.has(cushion)) {
          originalCellTexts.set(cushion, cushion.innerHTML);
        }

        cushion.style.display = "flex";
        cushion.style.flexDirection = "row";
        cushion.style.alignItems = "center";
        cushion.style.padding = "3px 6px";
        cushion.style.width = "100%";

        const existing = cushion.querySelector(".fc-sticky-date-num");
        if (existing) {
          existing.textContent = dateText;
        } else {
          cushion.innerHTML = `
            <span class="fc-sticky-date-num" style="font-size:13px;font-weight:800;line-height:1.2;">${dateText}</span>
          `;
        }
      });
    };

    const restoreHeaderCells = () => {
      originalCellTexts.forEach((html, cushion) => {
        cushion.innerHTML = html;
        cushion.style.display = "";
        cushion.style.flexDirection = "";
        cushion.style.alignItems = "";
        cushion.style.padding = "";
        cushion.style.width = "";
      });
      originalCellTexts.clear();
    };

    const applyHeaderFixed = () => {
      if (isHeaderFixed) return;
      const fcColHeader = getColHeader();
      if (!fcColHeader) return;

      const navbarH = getNavbarHeight();
      const headerH = fcColHeader.getBoundingClientRect().height;
      const tableW = getTableWidth();

      headerPlaceholder = document.createElement("tr");
      headerPlaceholder.style.height = `${headerH}px`;
      headerPlaceholder.style.display = "table-row";
      if (fcColHeader.parentNode) {
        fcColHeader.parentNode.insertBefore(
          headerPlaceholder,
          fcColHeader.nextSibling,
        );
      }

      fcColHeader.style.position = "fixed";
      // Below the month arrows, which stick at the top with it.
      fcColHeader.style.top = `${navbarH + STICKY_NAV_HEIGHT}px`;
      fcColHeader.style.width = `${tableW}px`;
      fcColHeader.style.left = isMemberCalendar ? "320px" : "307px";
      fcColHeader.style.zIndex = "11";
      fcColHeader.style.backgroundColor =
        "var(--background-primary-color, #1a1a1a)";

      setStickyNav({
        top: navbarH,
        left: fcColHeader.style.left,
        width: tableW,
      });
      isHeaderFixed = true;
    };

    const removeHeaderFixed = () => {
      if (!isHeaderFixed) return;
      const fcColHeader = getColHeader();
      if (fcColHeader) {
        fcColHeader.style.position = "";
        fcColHeader.style.top = "";
        fcColHeader.style.width = "";
        fcColHeader.style.zIndex = "";
        fcColHeader.style.backgroundColor = "";
      }
      if (headerPlaceholder && headerPlaceholder.parentNode) {
        headerPlaceholder.parentNode.removeChild(headerPlaceholder);
      }
      headerPlaceholder = null;
      isHeaderFixed = false;
      setStickyNav(null);
      restoreHeaderCells();
    };

    const handleScroll = () => {
      const toolbarEl = toolbarRowRef.current;
      if (!toolbarEl) return;

      const navbarH = getNavbarHeight();
      const toolbarBottomFromTop = toolbarEl.getBoundingClientRect().bottom;

      if (toolbarBottomFromTop <= navbarH - 20) {
        applyHeaderFixed();

        const weekRows = document.querySelectorAll(
          ".fc .fc-daygrid-body > table > tbody > tr",
        );
        const fcColHeader = getColHeader();
        const headerBottom = fcColHeader
          ? fcColHeader.getBoundingClientRect().bottom
          : navbarH + 40;

        let currentWeekRow = null;
        weekRows.forEach((row) => {
          const rowRect = row.getBoundingClientRect();
          if (rowRect.top <= headerBottom + 2) {
            currentWeekRow = row;
          }
        });

        if (currentWeekRow) {
          injectDatesIntoHeader(currentWeekRow);
        }

        if (fcColHeader) {
          const tableW = getTableWidth();
          fcColHeader.style.width = `${tableW}px`;
          setStickyNav((prev) =>
            prev && prev.width !== tableW ? { ...prev, width: tableW } : prev,
          );
        }
      } else {
        removeHeaderFixed();
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    const resizeObserver = new ResizeObserver(() => {
      const fcColHeader = getColHeader();
      if (fcColHeader && fcColHeader.style.position === "fixed") {
        const tableW = getTableWidth();
        fcColHeader.style.width = `${tableW}px`;
        setStickyNav((prev) =>
          prev && prev.width !== tableW ? { ...prev, width: tableW } : prev,
        );
      }
    });
    if (toolbarRowRef.current) {
      resizeObserver.observe(toolbarRowRef.current);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
      removeHeaderFixed();
    };
  }, [
    selectedWorkouts.length,
    events.length,
    show_back_button,
    programme?.difficulty_level,
  ]);
  // -----------------------------------------------------------

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div
      className="container-fluid full-calendar-toolbar"
      style={{ position: "relative" }}
    >
      {isPasted && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" />
        </div>
      )}
      {/* Month arrows stick above the day-name header once the toolbar is scrolled away. */}
      {stickyNav && (
        <div
          className="d-flex align-items-center"
          style={{
            position: "fixed",
            top: stickyNav.top,
            left: stickyNav.left,
            width: stickyNav.width,
            height: STICKY_NAV_HEIGHT,
            zIndex: 11,
            backgroundColor: "var(--background-primary-color, #1a1a1a)",
          }}
        >
          <div className="btn-group toollbar-group-buttons group-buttons-font-size-on-sm">
            <button
              className="small-contained-button"
              aria-label="Previous month"
              onClick={() => handleStickyNextPrev("prev")}
            >
              <ArrowBackIosIcon />
            </button>
            <button
              className="small-contained-button"
              aria-label="Next month"
              onClick={() => handleStickyNextPrev("next")}
            >
              <ArrowForwardIosIcon />
            </button>
          </div>
        </div>
      )}
      {/* Toolbar: action buttons + calendar nav — ref used for sticky header */}
      <div ref={toolbarRowRef}>
        {/* Row 1: Action buttons (right side) */}
        <div className="row align-items-center mb-2">
          <div className="col-12">
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              justifyContent="space-between"
              alignItems={{ xs: "stretch", sm: "center" }}
              flexWrap="wrap"
            >
              {/* Left placeholder for layout balance */}
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap />
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                useFlexGap
                justifyContent={{ xs: "flex-start", sm: "flex-end" }}
              >
                {/* Notepad */}
                <Tooltip title="Open Notepad" arrow>
                  <IconButton
                    size="small"
                    onClick={handleOpen}
                    sx={{
                      bgcolor: "primary.main",
                      color: "#fff",
                      borderRadius: "8px",
                      px: 1.2,
                      py: 0.6,
                      "&:hover": { bgcolor: "primary.dark" },
                    }}
                  >
                    <NoteAltOutlinedIcon fontSize="small" />
                    <span
                      style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}
                    >
                      Notepad
                    </span>
                  </IconButton>
                </Tooltip>

                {/* Review Date */}
                {show_back_button && (
                  <Tooltip title="Set Review Date" arrow>
                    <IconButton
                      size="small"
                      onClick={() => setIsReviewOpen(true)}
                      sx={{
                        bgcolor: "primary.main",
                        color: "#fff",
                        borderRadius: "8px",
                        px: 1.2,
                        py: 0.6,
                        "&:hover": { bgcolor: "primary.dark" },
                      }}
                    >
                      <EventAvailableOutlinedIcon fontSize="small" />
                      <span
                        style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}
                      >
                        Review Date
                      </span>
                    </IconButton>
                  </Tooltip>
                )}

                {/* Difficulty Level */}
                {show_back_button && programme?.difficulty_level && (
                  <Tooltip title="Set Difficulty Level" arrow>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setOpenLevels(true);
                        setIsOpen("EDIT");
                      }}
                      sx={{
                        bgcolor: "primary.main",
                        color: "#fff",
                        borderRadius: "8px",
                        px: 1.2,
                        py: 0.6,
                        "&:hover": { bgcolor: "primary.dark" },
                      }}
                    >
                      <TuneOutlinedIcon fontSize="small" />
                      <span
                        style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}
                      >
                        Difficulty
                      </span>
                    </IconButton>
                  </Tooltip>
                )}

                {/* View Compliance */}
                {harmonyRingEnabled &&
                  show_back_button &&
                  programme?.is_harmony_ring_enabled && (
                  <Tooltip title="View Compliance Graph" arrow>
                    <IconButton
                      size="small"
                      onClick={() => handleViewGraph(programme?._id)}
                      sx={{
                        bgcolor: "primary.main",
                        color: "#fff",
                        borderRadius: "8px",
                        px: 1.2,
                        py: 0.6,
                        "&:hover": { bgcolor: "primary.dark" },
                      }}
                    >
                      <BarChartOutlinedIcon fontSize="small" />
                      <span
                        style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}
                      >
                        Compliance
                      </span>
                    </IconButton>
                  </Tooltip>
                )}
              </Stack>
            </Stack>
          </div>
        </div>

        {/* Row 2: Calendar nav controls (prev/next, month, today) */}
        <div className="row align-items-center mb-1 gy-2">
          {/* Prev/Next */}
          <div className="col-12 col-sm-4 text-start">
            <div className="d-flex align-items-center">
              <div className="btn-group toollbar-group-buttons group-buttons-font-size-on-sm">
                <button
                  className="small-contained-button"
                  onClick={() => handleChangeNextPrev("prev")}
                >
                  <ArrowBackIosIcon />
                </button>
                <button
                  className="small-contained-button"
                  onClick={() => handleChangeNextPrev("next")}
                >
                  <ArrowForwardIosIcon />
                </button>
              </div>
              {manualLoading && (
                <CircularProgress size={16} style={{ marginLeft: "8px" }} />
              )}
            </div>
          </div>

          {/* Month title */}
          <div className="col-12 col-sm-4 text-sm-center text-start order-sm-0">
            <h3 className="font-size-on-sm mb-0">{getCenteredText()}</h3>
          </div>

          {/* Expand / Collapse / Today */}
          <div className="col-12 col-sm-4 d-flex align-items-center justify-content-sm-end justify-content-start flex-wrap gap-1">
            {events.length > 0 && (
              <>
                <Button
                  size="small"
                  onClick={handleExpandAll}
                  startIcon={<KeyboardArrowDownIcon />}
                  sx={{
                    bgcolor: "grey.700",
                    color: "#fff",
                    borderRadius: "8px",
                    px: 1,
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    py: 0.5,
                    "&:hover": { bgcolor: "grey.900" },
                  }}
                >
                  Expand All
                </Button>

                <Button
                  size="small"
                  onClick={handleCollapseAll}
                  startIcon={<KeyboardArrowUpIcon />}
                  sx={{
                    bgcolor: "grey.700",
                    color: "#fff",
                    borderRadius: "8px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    px: 1,
                    py: 0.5,
                    "&:hover": { bgcolor: "grey.900" },
                  }}
                >
                  Collapse All
                </Button>
              </>
            )}
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={() => goToToday()}
            >
              Today
            </Button>
          </div>
        </div>
      </div>
      {/* end toolbarRowRef wrapper */}

      {/* Alerts */}
      {difficultyProgram && difficultyProgram.length > 0 && (
        <div className="mb-1">
          <Alert
            sx={{
              textAlign: "left",
              width: "100%",
              backgroundColor: "#ff7f00",
              color: "#fff",
              "& .MuiAlert-icon": { color: "#fff" },
            }}
            severity="warning"
          >
            Difficulty level is not set for the following programs for this
            member, please set the difficulty level in the member's programs to
            enable viewing or adding tasks to their programming calendar:{" "}
            {difficultyProgram.map((p) => p?.programme_title).join("; ")}
            {"; "}
          </Alert>
        </div>
      )}
      {menstrual_cycle?.gender === "female" &&
        menstrual_cycle?.is_menstrual_cycle &&
        menstrual_cycle?.permission_cycle && (
          <div className="mb-1">
            <Alert
              sx={{
                textAlign: "left",
                width: "100%",
                backgroundColor: "#FF7F00",
                color: "#fff",
                "& .MuiAlert-icon": { color: "#fff" },
              }}
              severity="warning"
            >
              This member is currently on her menstrual cycle. Please avoid
              assigning heavy workouts and adjust the training accordingly.
            </Alert>
          </div>
        )}
      <div className="row">
        <div
          className="col-md-12 full-calendar full-calendar-new-flow order-4"
          onMouseLeave={() => setHoveredDate(null)}
        >
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: "today prev,next",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            className="fc-day-sun fc-toolbar-chunk fc eventimage fc-col-header-cell-cushion fc-today-button fc-right fc-prev-button fc-right fc-next-button fc-dayGridMonth-button fc-timeGridWeek-button fc-timeGridDay-button fc-daygrid-day-number fc-daygrid-day-top"
            eventContent={renderEventContent}
            events={eventsWithOpenState}
            initialView="dayGridMonth"
            initialDate={initialDate || undefined}
            dayCellContent={renderDayCell}
            editable={true}
            height="auto"
            stickyHeaderDates={false}
            selectable={true}
            selectMirror={true}
            eventDrop={handleEventDrop}
            eventOrder={eventOrderFunction}
            weekends={true}
            fixedWeekCount={false}
            moreLinkContent={function (args) {
              return "+" + args.num;
            }}
            moreLinkClick={function (args) {
              handleClickDate(args);
            }}
            dayCellDidMount={(arg) => {
              const cell = arg.el;
              cell.addEventListener("mouseover", () => {
                handleCellHover(arg);
              });
            }}
          />
        </div>
        <div className="col-lg-3 col-md-12 order-2 order-lg-2 mt-3">
          <Modal open={openEditor} onClose={handleCloseEditor}>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "90%",
                width: "500px",
              }}
            >
              <h2>Notepad</h2>
              <GeneralCkeditor
                setInputs={setInputs}
                inputs={inputs}
                name="description"
                editorHeight={350}
              />
            </div>
          </Modal>
        </div>
      </div>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to Delete?"}
        handleAgree={handleDelete}
      />
      <CustomConfirmation
        openDelete={openMultiDelete}
        setOpenDelete={setOpenMultiDelete}
        title={"Are you sure you want to Delete?"}
        handleAgree={handleDeleteMultipul}
      />
      <CustomConfirmation
        openDelete={openDragConfig}
        setOpenDelete={closeDragConfig}
        title={"Are you sure you want to Move it?"}
        handleAgree={handleDraged}
        isLoading={isDragedloading}
      />
      <CustomConfirmation
        openDelete={openCopyPasteConfig}
        setOpenDelete={closeCopyPasteConfig}
        title={"Do you want to paste it here?"}
        handleAgree={handleCopyPaste}
        isLoading={isPasted}
      />
      <AddWorkoutPopupClient
        open={drawerState}
        setOpen={handleCloseAddModal}
        date={selectedDate}
        programme={programmeData}
        memberInfo={memberInfo}
        member_id={member_id}
        reloadList={reloadList}
        member_vdot={member_vdot}
        member_vdot_info={member_vdot_info}
        setEditWorkputData={setEditWorkputData}
        setEvents={setEvents}
        events={events}
      />
      <EditWorkoutPopupClient
        open={editItrationDrawerState}
        setOpen={handleCloseEditModal}
        date={selectedDate}
        programme={programmeData}
        member_id={member_id}
        data={editWorkputData}
        reloadList={reloadList}
        member_vdot={member_vdot}
        member_vdot_info={member_vdot_info}
        setEvents={setEvents}
        events={events}
      />
      <CustomPopoverNew
        is_hide_icon={difficultyLevel ? false : true}
        isOpenPop={openLevels}
        isClosePop={difficultyLevel ? setOpenLevels : ""}
        title={
          isOpen === "ADD" ? "Set Difficulty Level" : "Change Difficulty Level"
        }
        componentToPassDown={
          <div className="px-4 pb-3">
            <FormControl fullWidth sx={{ mb: 2, mt: 2 }} required>
              <InputLabel id="demo-simple-select-label">
                Difficulty Level
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="difficulty_level"
                value={difficultyLevel}
                label="Difficulty Level"
                onChange={(e) => {
                  setDifficultyLevel(e.target.value);
                }}
              >
                <MenuItem value="novice">Novice</MenuItem>
                <MenuItem value="intermediate">Intermediate</MenuItem>
                <MenuItem value="advanced">Advanced</MenuItem>
              </Select>
            </FormControl>
            <div
              className="mb-2"
              style={{
                width: "500px",
                maxWidth: "100%",
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox checked={checked} onChange={handleChangeCheck} />
                  }
                  label={
                    isOpen === "ADD"
                      ? "Set a difficulty level for this program, specifically for this member. (Please note that this change will set the difficulty level specifically for this member on the Client Portal.)"
                      : "Change the difficulty level for this program, specifically for this member. (Please note that this change will update the difficulty level specifically for this member on the Client Portal.)"
                  }
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "gray",
                      fontSize: "14px",
                    },
                  }}
                />
              </FormGroup>
            </div>
            <div className="text-end">
              <Button
                variant="contained"
                disabled={!checked}
                onClick={handleAddLevels}
              >
                Save
              </Button>
            </div>
          </div>
        }
      />
      <CustomPopoverNew
        width="550px"
        isOpenPop={isReviewOpen}
        isClosePop={setIsReviewOpen}
        title="Review Date"
        componentToPassDown={
          <div className="px-4 pb-3">
            <ReviewsDateMember
              programme={programme}
              isClosePop={setIsReviewOpen}
              member_id={member_id}
            />
          </div>
        }
      />
      <CustomPopoverNew
        isOpenPop={isPastedWorkouts}
        isClosePop={setIsPastedWorkouts}
        title="Add To Programme/Member"
        componentToPassDown={
          <div className="px-4 pb-3">
            <PastedWorkoutsClient
              selectedWorkouts={selectedWorkouts}
              setSelectedWorkouts={setSelectedWorkouts}
              setDataCopy={setDataCopy}
              setIsPastedWorkouts={setIsPastedWorkouts}
            />
          </div>
        }
      />

      {/* Floating action buttons — shown when workouts are selected */}
      {selectedWorkouts.length > 0 && (
        <div
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 99999,
            display: "flex",
            flexDirection: "row",
            gap: 10,
            alignItems: "center",
          }}
        >
          <Tooltip title="Delete selected workouts" arrow placement="top">
            <IconButton
              size="small"
              onClick={handleOpenMultiDelete}
              sx={{
                bgcolor: "error.main",
                color: "#fff",
                borderRadius: "8px",
                px: 1.5,
                py: 0.8,
                boxShadow: 4,
                fontSize: 12,
                "&:hover": { bgcolor: "error.dark" },
              }}
            >
              <DeleteIcon fontSize="small" />
              <span style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}>
                Delete ({selectedWorkouts.length})
              </span>
            </IconButton>
          </Tooltip>

          <Tooltip title="Copy to Programme / Member" arrow placement="top">
            <IconButton
              size="small"
              onClick={handleProgrammeMember}
              sx={{
                bgcolor: "primary.main",
                color: "#fff",
                borderRadius: "8px",
                px: 1.5,
                py: 0.8,
                boxShadow: 4,
                "&:hover": { bgcolor: "primary.dark" },
              }}
            >
              <ContentPasteIcon fontSize="small" />
              <span style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}>
                Copy
              </span>
            </IconButton>
          </Tooltip>

          <Tooltip title="Discard selection" arrow placement="top">
            <IconButton
              size="small"
              onClick={() => {
                setSelectedWorkouts([]);
                setDataCopy(false);
              }}
              sx={{
                bgcolor: "grey.600",
                color: "#fff",
                borderRadius: "8px",
                px: 1.5,
                py: 0.8,
                boxShadow: 4,
                "&:hover": { bgcolor: "grey.800" },
              }}
            >
              <CloseIcon fontSize="small" />
              <span style={{ fontSize: 12, marginLeft: 4, fontWeight: 500 }}>
                Discard
              </span>
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  );
}

export default GeneralCalendarClient;
